import { render, staticRenderFns } from "./unLogin.vue?vue&type=template&id=2250323c&scoped=true&"
import script from "./unLogin.vue?vue&type=script&lang=js&"
export * from "./unLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2250323c",
  null
  
)

export default component.exports